export default __webpack_public_path__ + "static/media/Teams.84c592b7.png";